<template>
  <sweet-modal
    :icon="modalIcon"
    ref="modal"
    overlay-theme="dark"
    :modal-theme="isContrast ? 'dark' : 'light'"
  >
    <span class="display-4">{{ message }}</span>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
export default {
  components: {
    SweetModal,
  },
  computed: {
    contrast: function () {
      return this.$store.getters.getContrast;
    },
    isContrast: function () {
      return this.contrast != "none";
    },
    modalIcon() {
      switch (this.type) {
        case "warn":
          return "warning";
        case "error":
          return "error";
        default:
          return "";
      }
    },
  },
  data() {
    return {
      showModal: false,
      message: "",
      type: "",
    };
  },
  watch: {
    showModal: function (newVal) {
      if (newVal == true) {
        this.$refs.modal.open();
      } else {
        this.$refs.modal.close();
      }
    },
  },
  methods: {
    show(type, message) {
      this.type = type;
      this.message = message;
      this.showModal = true;
        this.$refs.modal.open();
    },
    close() {},
  },
};
</script>